import { api } from '.'

export const megaActivationApi = api.injectEndpoints({
  endpoints: build => ({
    createActivation: build.mutation({
      query: ({ mobile_phone }: { mobile_phone: string }) => ({
        url: `/mega_cards/activation-create-lead/`,
        method: 'POST',
        body: { mobile_phone }
      })
    }),
    activationVerify: build.mutation({
      query: ({ code, mobile_phone }: { code: string; mobile_phone: string }) => ({
        url: `/mega_cards/activation-verify/`,
        method: 'POST',
        body: { mobile_phone, code }
      })
    }),
    cardActivation: build.mutation({
      query: ({ idn }: { idn: string }) => ({
        url: `/mega_cards/activation-create/`,
        method: 'POST',
        body: { idn }
      })
    }),
    checkActivation: build.query({
      query: ({ uuid }) => ({
        url: `/mega_cards/activation/${uuid}/status/`,
        method: 'GET'
      })
    })
  })
})

export const {
  useCreateActivationMutation,
  useActivationVerifyMutation,
  useCardActivationMutation,
  useCheckActivationQuery
} = megaActivationApi
